import * as React from 'react';
import { Form } from '@beehive/components';
import PropTypes from 'prop-types';
import messages from 'messages/Workbench/ProjectDetail';
import { isBlank } from 'utils';

export interface PayInfoProps {
  prefixCls: string;
}

const HALF_COL_PROPS = {
  advance_info: {
    itemColProps: { span: 24 },
    itemLabelColProps: { span: 3 },
    itemInputColProps: { span: 18 },
  },
  itemColProps: { span: 12 },
  itemLabelColProps: { span: 6 },
  itemInputColProps: { span: 18 },
};
const FORM_PROPS_1 = {
  mode: 'show',
  isLabelVertical: false,
  className: 'payInfo',
  ...HALF_COL_PROPS,
};
const FORM_ITEMS_1 = [
  { key: 'advance_info', label: 'advance_info' },
  { key: 'quote_price', label: 'quote_price' },
  { key: 'settle_price', label: 'settle_price' },
];

class PayInfo extends React.Component<PayInfoProps, any> {
  public static contextTypes = {
    intl: PropTypes.object,
    detail: PropTypes.object,
  };

  public render() {
    const { intl, detail = {} } = this.context;
    const { prefixCls } = this.props;
    const className = `${prefixCls}-base-info`;
    const { project_suppliers= [] } = detail;
    const accountInfo = project_suppliers.length > 0 ? project_suppliers[0].advance_info : '';
    return (
      <div className={className}>
        <Form {...FORM_PROPS_1} >
          {FORM_ITEMS_1.map((item: any) => {
            const label = `${intl.formatMessage(
              messages[item.label],
            )}${intl.formatMessage(messages.colon)}`;
            const value = item.key === 'advance_info' ? accountInfo : detail[item.key];
            return (
              <Form.Item
                {...item}
                {...HALF_COL_PROPS[item.key]}
                key={item.key}
                label={label}
                className={`${className}-${item.key}`}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: isBlank(value) ? '--' : value,
                  }}
                />
              </Form.Item>
            );
          })}
        </Form>
      </div>
    );
  }
}

export default PayInfo;
